import React, { useState } from "react";
import { Check, Copy } from "lucide-react";

const CopyValueButton: React.FC<{ value: string; label: string }> = ({
  value,
  label,
}) => {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    await navigator.clipboard.writeText(value);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <button
      type="button"
      onClick={copy}
      aria-label={label}
      className="flex items-center gap-1.5 text-xs px-2.5 py-1.5 rounded-lg border border-warm-border text-warm-text-secondary hover:text-warm-text-primary hover:bg-warm-bg-elevated transition-colors flex-shrink-0"
    >
      {copied ? <Check size={13} /> : <Copy size={13} />}
      {copied ? "Copied" : "Copy"}
    </button>
  );
};

export default CopyValueButton;
